import { computed } from 'vue';

import { useWarehouseStore } from '@/stores/useWarehouseStore';

export function useSelectedWarehouse() {
  const warehouseStore = useWarehouseStore();

  const warehouse = computed(() => warehouseStore.selectedWarehouse);
  const warehouseId = computed(() => warehouseStore.selectedWarehouseId);
  const warehouseTimezone = computed(() => warehouseStore.selectedWarehouseTimezone);
  const warehouseFeatures = computed(() => warehouseStore.selectedWarehouseFeatures);

  return {
    selectedWarehouse: warehouse,
    selectedWarehouseId: warehouseId,
    selectedWarehouseTimezone: warehouseTimezone,
    selectedWarehouseFeatures: warehouseFeatures
  };
}

/**
 * @typedef {import('@satellite/composables/useWarehousesPresenterV2').WarehouseDetails} WarehouseDetails
 * @typedef {import('vue').ComputedRef<WarehouseDetails>} WarehouseDetailsComputedRef
 */
